/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

/**
 * Rxjs imports.
 */
import { Subscription, timer } from 'rxjs';

/**
 * Constant imports.
 */
import { NO_INFO_TYPE } from 'src/app/constants/app.constants';

/**
 * Service imports.
 */
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * When Information are not available.
 */
@Component({
  selector: 'app-no-info-available',
  templateUrl: './no-info-available.component.html',
  styleUrls: ['./no-info-available.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoInfoAvailableComponent implements OnInit, OnDestroy {

  /**
   * Type of no information.
   * 0 for the whole list
   * 1 for the single.
   * 2 for the thumbnail.
   */
  @Input() noInfoType: number;
  @Input() noInfoSrc: string;
  @Input() noInfoHeading: string;
  @Input() noInfoParagraph: string;
  @Input() noInfoButtonText: string;
  @Input() loadingState;

  /**
   * Timer for the no info play usually same as the default time.
   */
  @Input() private timer: number;

  /**
   *
   */
  @Output() onGoBack: EventEmitter<number> = new EventEmitter();
  @Output() onToNext: EventEmitter<number> = new EventEmitter();

  /**
   * TO unsubscribe the subscription.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * No info type constant.
   * 0 for the whole list
   * 1 for the single view detail
   * 2 for the thumbnail.
   */
  public NO_INFO_TYPE = NO_INFO_TYPE;

  /**
   * Create the necessary instances.
   */
  constructor(public mls: NewLanguageService) { }

  /**
   * Start the timer in case of single view detail.
   */
  ngOnInit(): void {
    if (this.noInfoType === NO_INFO_TYPE.SINGLE) {
      this.startTheTimer();
    }
  }

  /**
   * Start the timer according to the timer value passed in ms.
   */
  startTheTimer(): void {
    this.subscriptions.add(timer(this.timer).subscribe(() => this.onToNext.emit()));
  }

  /**
   * Emit the go back click.
   */
  goBack(): void {
    this.onGoBack.emit();
  }

  /**
   * Remove the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
